import { Alert, Button, Stack } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useOrgConfigIssuesBannerInfo } from '../../hooks/useOrgConfigIssuesBannerInfo'
import { useOrgConfigIssuesSnooze } from '../../hooks/useOrgConfigIssuesSnooze'
import { ReviewSetupDialog } from './ReviewSetupDialog'

export const OrgConfigIssuesBanner = () => {
  const { t } = useTranslation('common', { keyPrefix: 'org-config-issues.banner' })
  const { shouldShowBanner, issues, severity, headlineCount, isLoading } = useOrgConfigIssuesBannerInfo()
  const { isSnoozed, snooze } = useOrgConfigIssuesSnooze()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  // The counts resolve from three independent queries, so rendering before they settle shows a short undercount
  if (isLoading || !shouldShowBanner || (isSnoozed && severity === 'warning')) return null

  const closeDialog = () => setIsDialogOpen(false)

  const snoozeAndClose = () => {
    snooze()
    closeDialog()
  }

  return (
    <Stack mb={4}>
      <Alert
        severity={severity}
        action={
          <Button variant="text" color="secondary" size="small" onClick={() => setIsDialogOpen(true)}>
            {t('action')}
          </Button>
        }
      >
        {t(severity === 'error' ? 'title' : 'warning-title', { count: headlineCount })}
      </Alert>
      <ReviewSetupDialog
        isOpen={isDialogOpen}
        issues={issues}
        severity={severity}
        onClose={closeDialog}
        onSnooze={snoozeAndClose}
      />
    </Stack>
  )
}
